import Env from '@/common/constants/Env.json';
import EnvStage from '@/common/constants/Env_stage.json';
import EnvProd from '@/common/constants/Env_prod.json';
import EnvLocal from '@/common/constants/Env_local.json';

export let CODE_ENV_LIST = Env;
if (process.env.VUE_APP_MODE === 'local') {
  CODE_ENV_LIST = { ...Env, ...EnvLocal };
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage;
} else if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = EnvProd;
}

export const LOCALE_MAP = {
  ko: 'Kr',
  vn: 'Vn',
  en: 'En'
};

// locale -> 서버 language code
export const TRANSLATE_MAP = {
  ko: 'ko',
  vn: 'vi',
  en: 'en'
};

export const MAIN_TAB = {
  PROMOTION: 'PROMOTION',
  NEW: 'NEW'
};

export const CHAT_ORDER_TAB = {
  ALL: 'ALL',
  INCOME: 'INCOME',
  ON_GOING: 'ON_GOING',
  RESERVATION: 'RESERVATION'
};

export const POINT_TAB = {
  EARN: 'EARN',
  USE: 'USE'
};

export const STORE_CONDITION_TYPE = {
  STORE_ORDER_BY_CONDITION: {
    constant: 'STORE_ORDER_BY_CONDITION',
    store: 'storeOrderByCondition'
  },
  STORE_DELIVERY_FEE_CONDITION: {
    constant: 'STORE_DELIVERY_FEE_CONDITION',
    store: 'storeDeliveryFeeCondition'
  },
  STORE_REQUIRED_PAY_AMOUNT_CONDITION: {
    constant: 'STORE_REQUIRED_PAY_AMOUNT_CONDITION',
    store: 'storeRequiredPayAmountCondition'
  },
  STORE_STAR_CONDITION: {
    constant: 'STORE_STAR_CONDITION',
    store: 'storeStarCondition'
  },
  STORE_ETC_CONDITION: {
    constant: 'STORE_ETC_CONDITION',
    store: 'storeEtcCondition'
  }
};

export const ORDER_STATUS = {
  ORDER_INCOME: 'ORDER_INCOME',
  ORDER_CHECK: 'ORDER_CHECK',
  COOKING: 'COOKING',
  DELIVERY: 'DELIVERY',
  DELIVERY_ARRIVED: 'DELIVERY_ARRIVED',
  DELIVERY_COMPLETED: 'DELIVERY_COMPLETED',
  PACKAGING_COMPLETED: 'PACKAGING_COMPLETED',
  PICKUP_COMPLETED: 'PICKUP_COMPLETED',
  ORDER_CANCELLED: 'ORDER_CANCELLED'
};

export const BUSINESS_HOURS = {
  WEEK: { Kr: '매일(월~일)', Vn: 'Everyday', value: 'WEEK' },
  WEEKDAY: { Kr: '평일(월~금)', Vn: 'Weekday', value: 'WEEKDAY' },
  WEEKEND: { Kr: '주말(토~일)', Vn: 'Weekend', value: 'WEEKEND' },
  MON: { Kr: '월요일', Vn: 'MON', value: 'MON' },
  TUE: { Kr: '화요일', Vn: 'TUE', value: 'TUE' },
  WED: { Kr: '수요일', Vn: 'WED', value: 'WED' },
  THU: { Kr: '목요일', Vn: 'THU', value: 'THU' },
  FRI: { Kr: '금요일', Vn: 'FRI', value: 'FRI' },
  SAT: { Kr: '토요일', Vn: 'SAT', value: 'SAT' },
  SUN: { Kr: '일요일', Vn: 'SUN', value: 'SUN' }
};

export const WEEK_INDEX = {
  EVERY_WEEK: { Kr: '매주', Vn: 'EVERY_WEEK', value: 'EVERY_WEEK' },
  EVERY_FIRST: { Kr: '매 월 첫째주', Vn: 'EVERY_FIRST', value: 'EVERY_FIRST' },
  EVERY_SECOND: {
    Kr: '매 월 둘째주',
    Vn: 'EVERY_SECOND',
    value: 'EVERY_SECOND'
  },
  EVERY_THIRD: { Kr: '매 월 셋째주', Vn: 'EVERY_THIRD', value: 'EVERY_THIRD' },
  EVERY_FOURTH: {
    Kr: '매 월 넷째주',
    Vn: 'EVERY_FOURTH',
    value: 'EVERY_FOURTH'
  },
  EVERY_FIFTH: { Kr: '매 월 다섯째주', Vn: 'EVERY_FIFTH', value: 'EVERY_FIFTH' }
};

export const WEEKEND_INDEX = {
  MON: { label: '월요일', value: 'MON' },
  TUE: { label: '화요일', value: 'TUE' },
  WED: { label: '수요일', value: 'WED' },
  TUR: { label: '목요일', value: 'THU' },
  FRI: { label: '금요일', value: 'FRI' },
  SAT: { label: '토요일', value: 'SAT' },
  SUN: { label: '일요일', value: 'SUN' }
};

export const MINUTES = ['00', '10', '20', '30', '40', '50'];
export const HOURS = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23'
];

export const BUSINESS_STATUS = {
  OPEN: '영업중',
  CLOSE: '영업종료',
  BREAK: '휴식시간'
};

export const SUPPORT_PACKING_OPTIONS = {
  false: '영업중',
  CLOSE: '영업종료',
  BREAK: '휴식시간'
};

export const EMIT_EVENT = {
  BADGE: 'BADGE',
  LATEST: 'LATEST',
  ORDER: 'ORDER_STATUS_CHANGED',
  STORE_DISABLED: 'STORE_DISABLED'
};
export const LOGIN_TOKEN_NAME = 'unionglobal_jtw_user_token';
export const NATIONAL_CODE = [
  { label: '+84', value: 84 },
  { label: '+82', value: 82 }
];

export const TERMS = {
  TERMS: 'terms',
  PRIVACY: 'privacy',
  LOCATION: 'geolocation'
};

export const DASH_BOARD_PERIOD_CONDITION = {
  DASHBOARD_DAY: 'DASHBOARD_DAY',
  DASHBOARD_WEEK: 'DASHBOARD_WEEK',
  DASHBOARD_MONTH: 'DASHBOARD_MONTH'
};
export const DASH_BOARD_ORDER_CONDITION = {
  DASHBOARD_ORDER_ALL: 'DASHBOARD_ORDER_ALL',
  DASHBOARD_ORDER_COMPLETED: 'DASHBOARD_ORDER_COMPLETED',
  DASHBOARD_ORDER_CANCELLED: 'DASHBOARD_ORDER_CANCELLED'
};

export const SNS_LOGIN = {
  // 네이버(N), 카카오(K), 애플(A), 구글(G), 페이스북(F)
  NAVER: { native: 'N', server: 'NAVER' },
  KAKAO: { native: 'K', server: 'KAKAO' },
  APPLE: { native: 'A', server: 'APPLE' },
  GOOGLE: { native: 'G', server: 'GOOGLE' },
  FACEBOOK: { native: 'F', server: 'FACEBOOK' }
};

export const SSE_TYPE = {
  chat_status: 'CHAT',
  order_status: 'ORDER_STATUS_CHANGED',
  store_disabled: 'STORE_DISABLED',
  new_chat: 'NEW_CHAT',
  leave_chat: 'LEAVE_CHAT'
};

export const isDev = () => {
  return (process.env.VUE_APP_MODE ?? 'development') === 'development' && process.env.NODE_ENV === 'development';
};

export const ORIGIN_FILE_PATH = 'https://upload.youthmarketvn.com/uploadImage';

const IMAGE_ORIGIN_FALLBACK_MAP = new Map();
let isImageFallbackHandlerAttached = false;

const normalizeImagePath = (path = '') => {
  if (path && !path.startsWith('/')) return '/' + path;
  return path;
};

const buildImagePath = (path = '', resolution = 'origin') => {
  return `${CODE_ENV_LIST.S3_FILE_SERVER_URL}/${resolution}${normalizeImagePath(path)}`;
};

const normalizeImageUrl = (url = '') => {
  if (!url) return '';
  try {
    return decodeURI(new URL(url).href);
  } catch {
    try {
      return decodeURI(url);
    } catch {
      return url;
    }
  }
};

const attachImageOriginFallbackHandler = () => {
  if (isImageFallbackHandlerAttached || typeof window === 'undefined') return;

  window.addEventListener(
    'error',
    (event) => {
      const target = event?.target;
      if (!target || target.tagName !== 'IMG') return;

      const failedSrc = normalizeImageUrl(target.currentSrc || target.src);
      const fallbackSrc = IMAGE_ORIGIN_FALLBACK_MAP.get(failedSrc);
      if (!failedSrc || !fallbackSrc || failedSrc === fallbackSrc) return;
      target.src = fallbackSrc;
    },
    true
  );

  isImageFallbackHandlerAttached = true;
};

export const getImagePath = (path = '', resolution = 'origin', useOriginFallback = true) => {
  if (/^https?:\/\//i.test(path)) return path;
  const currentPath = buildImagePath(path, resolution);

  if (!useOriginFallback || resolution === 'origin') return currentPath;

  const originPath = buildImagePath(path, 'origin');
  if (currentPath !== originPath) {
    IMAGE_ORIGIN_FALLBACK_MAP.set(normalizeImageUrl(currentPath), normalizeImageUrl(originPath));
    attachImageOriginFallbackHandler();
  }

  return currentPath;
  // return `${CODE_ENV_LIST.FILE_SERVER_URL}/${resolution}/${path}`;
};

export const getFilePath = (path = '') => {
  return `${CODE_ENV_LIST.FILE_SERVER_URL}/${path}`;
};

console.log('실행 환경 : ', process.env.NODE_ENV);

export default {};
